import { render, staticRenderFns } from "./Accountrefund.vue?vue&type=template&id=5ad24892&scoped=true&"
import script from "./Accountrefund.vue?vue&type=script&lang=js&"
export * from "./Accountrefund.vue?vue&type=script&lang=js&"
import style0 from "./Accountrefund.vue?vue&type=style&index=0&id=5ad24892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad24892",
  null
  
)

export default component.exports